import React from "react";
import { GoogleMap, Marker, Circle } from "@react-google-maps/api";
import { useGoogleMaps } from "../../contexts/google_map_context";

interface StaticMapProps {
  lat: number;
  lng: number;
  radius?: number;
}

const StaticMap: React.FC<StaticMapProps> = ({ lat, lng, radius }) => {
  const { isLoaded } = useGoogleMaps();

  const mapContainerStyle = {
    width: "100%",
    height: "300px",
  };

  const center = {
    lat: lat,
    lng: lng,
  };

  if (!isLoaded) {
    return <div>Loading map...</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={center}
      zoom={14}
      options={{
        disableDefaultUI: true,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: false,
      }}
    >
      <Marker position={center} />
      <Circle
        center={center}
        radius={radius ?? 1000}
        options={{
          strokeColor: "#2563eb",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#2563eb",
          fillOpacity: 0.35
        }}
      />
    </GoogleMap>
  );
};

export default StaticMap;
